import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DynamicForm from "components/DynamicForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProductValidationsThunk, productValidationSelector } from "store/reducers/product/productValidationSlice";

import {
  createValidationAssignmentsToMachineThunk,
  deleteValidationAssignmentsToMachineThunk,
  getValidationAssignmentsToMachinesThunk,
  validationAssignmentsToMachineSelector,
} from "store/reducers/product/validationAssignmentSlice";

const ValidationAssignmentToMachine = ({ machine }) => {
  const dispatch = useDispatch();
  const [production, setProduction] = React.useState(true);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [validation, setValidation] = React.useState("");
  const handleItemChange = (event) => {
    setValidation(event.target.value);
  };
  useEffect(() => {
    dispatch(getProductValidationsThunk());
  }, []);
  const validations = useSelector(productValidationSelector.selectAll);
  const validationAssignments = useSelector(
    validationAssignmentsToMachineSelector.selectAll
  ).filter((validation) => validation.machine === machine.id);

  useEffect(() => {
    dispatch(getValidationAssignmentsToMachinesThunk(machine.id));
  }, [machine]);

  const { status } = useSelector((state) => state.validationAssignments);

  const removeValidation = (id) => {
    dispatch(deleteValidationAssignmentsToMachineThunk(id));
  };

  const onCredentialFormatSubmit = (data) => {
    const request = {
      machine: machine.id,
      validation: validation.id,
      authentication: data,
      production
    };
    dispatch(createValidationAssignmentsToMachineThunk(request));
  };

  return (
    <>
      {validationAssignments.length > 0 && (
        <Box
          sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1,mb:2 }}
          padding={1}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {isSmallScreen ? "Name" : "Validation name"}
                  </TableCell>

                  <TableCell align="center" >
                    Logic
                  </TableCell>
                  {/* <TableCell >&nbsp;</TableCell> */}
                  <TableCell sx={{ width: 30 }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {validationAssignments.map(({ validation_detail, id }) => (
                  <TableRow
                    key={id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row" align="left">
                      {validation_detail.name}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {validation_detail.logic}
                    </TableCell>

                    {/* <TableCell align="center">
                      <LoadingButton
                        variant="outlined"
                        color="info"
                        // onClick={() => {
                        //   removeValidation(id);
                        // }}
                        loading={
                          status?.loading === "update" && status?.id === id
                        }
                      >
                        Edit
                      </LoadingButton>
                    </TableCell> */}

                    <TableCell align="right" sx={{ width: 30 }}>
                      <LoadingButton
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          removeValidation(id);
                        }}
                        loading={
                          status?.loading === "delete" && status?.id === id
                        }
                      >
                        Delete
                      </LoadingButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <Typography sx={{ mb: 1 }} variant="h5">Setup new validation</Typography>

      <Box display="flex">
        <FormControl sx={{ width: "100%" }} size="small">
          <InputLabel>Choose Validations</InputLabel>
          <Select
            value={validation}
            label="Choose validation"
            onChange={handleItemChange}
          >
            <MenuItem value={null}>
              <em>None</em>
            </MenuItem>
            {validations.map((validation) => (
              <MenuItem key={validation.id} value={validation}>
                {validation.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {validation && (
        <>
          <Typography variant="h6" color="gray" marginTop={1}>
            Do you want to add {validation.name} to this machine ?
          </Typography>
          <div>
            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  name="remember"
                  checked={production}
                  value={production}
                  color="primary"
                />
              }
              label="Production"
              onChange={(e) => setProduction(e.target.checked)}
              name="remember"
            />
          </div>
          {validation.credential_format ? (
            <>
              <Typography variant="caption" color="gray" marginTop={1}>
                {validation.name} required the following details to proceed
              </Typography>
              <DynamicForm
                items={validation.credential_format}
                buttonText="Submit"
                buttonType="outlined"
                grid={{ xs: 12, md: 12, lg: 12 }}
                loading={status?.loading === "create"}
                onSubmit={onCredentialFormatSubmit}
                sx={{ mt: 2 }}
              />
              {status?.error === "create" && (
                <Alert severity="error">Error occurred</Alert>
              )}
              {status?.success === "create" && (
                <Alert sx={{ mt: 3 }} severity="success">
                  Success
                </Alert>
              )}
            </>
          ) : (
            <>
              <LoadingButton
                loading={status?.loading === "create"}
                variant="outlined"
                type="submit"
                onClick={() => onCredentialFormatSubmit(null)}
              >
                Add this validation
              </LoadingButton>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ValidationAssignmentToMachine;
